<script setup lang="ts">
/**
 * A length in centimetres with a coarse and a fine step on either side:
 * −1 m · −10 cm · 7.00 m · +10 cm · +1 m. Every button says what it does, so
 * the value is reached in a few sure taps rather than by holding one down.
 */
const props = defineProps<{ modelValue: number; coarse: number; fine: number; min: number; max: number }>()
const emit = defineEmits<{ 'update:modelValue': [value: number] }>()

/** Whole metres read as metres, the rest as centimetres: the units sailors use for these */
const label = (by: number) => {
  const cm = Math.abs(by)
  return `${by < 0 ? '−' : '+'}${cm % 100 === 0 ? `${cm / 100} m` : `${cm} cm`}`
}
const step = (by: number) => emit('update:modelValue', Math.min(props.max, Math.max(props.min, props.modelValue + by)))
</script>

<template>
  <span class="stepper measure">
    <button :aria-label="label(-coarse)" @click="step(-coarse)">{{ label(-coarse) }}</button>
    <button :aria-label="label(-fine)" @click="step(-fine)">{{ label(-fine) }}</button>
    <span class="num value">{{ (modelValue / 100).toFixed(2) }} m</span>
    <button :aria-label="label(fine)" @click="step(fine)">{{ label(fine) }}</button>
    <button :aria-label="label(coarse)" @click="step(coarse)">{{ label(coarse) }}</button>
  </span>
</template>
